/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-use-before-define */
/* eslint-disable no-param-reassign */
/* eslint-disable no-redeclare */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable default-case */
/* eslint-disable radix */
/* eslint-disable prefer-spread */
/* eslint-disable no-void */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-plusplus */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-sequences */
/* eslint-disable no-func-assign */
/* eslint-disable no-return-assign */
/* eslint-disable func-names */
/* eslint-disable no-shadow */
/* eslint-disable no-proto */
/**
 * Max Poshusta | v1.0.2 | MIT License | https://github.com/maxshuty/accessible-web-components | https://www.linkedin.com/in/maxposhusta
 */

function _typeof(e) {
  return (_typeof = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
    ? function (e) {
      return typeof e;
    }
    : function (e) {
      return e
            && typeof Symbol === 'function'
            && e.constructor === Symbol
            && e !== Symbol.prototype
        ? 'symbol'
        : typeof e;
    })(e);
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) { throw new TypeError('Cannot call a class as a function'); }
}
function _defineProperties(e, t) {
  for (let n = 0; n < t.length; n++) {
    const r = t[n];
    (r.enumerable = r.enumerable || !1),
    (r.configurable = !0),
    'value' in r && (r.writable = !0),
    Object.defineProperty(e, r.key, r);
  }
}
function _createClass(e, t, n) {
  return (
    t && _defineProperties(e.prototype, t),
    n && _defineProperties(e, n),
    Object.defineProperty(e, 'prototype', { writable: !1 }),
    e
  );
}
function _inherits(e, t) {
  if (typeof t !== 'function' && t !== null) { throw new TypeError('Super expression must either be null or a function'); }
  (e.prototype = Object.create(t && t.prototype, {
    constructor: { value: e, writable: !0, configurable: !0 },
  })),
  Object.defineProperty(e, 'prototype', { writable: !1 }),
  t && _setPrototypeOf(e, t);
}
function _createSuper(n) {
  const r = _isNativeReflectConstruct();
  return function () {
    let e;
    const t = _getPrototypeOf(n);
    return _possibleConstructorReturn(
      this,
      r
        ? ((e = _getPrototypeOf(this).constructor),
        Reflect.construct(t, arguments, e))
        : t.apply(this, arguments),
    );
  };
}
function _possibleConstructorReturn(e, t) {
  if (t && (_typeof(t) === 'object' || typeof t === 'function')) return t;
  if (void 0 !== t) {
    throw new TypeError(
      'Derived constructors may only return object or undefined',
    );
  }
  return _assertThisInitialized(e);
}
function _assertThisInitialized(e) {
  if (void 0 === e) {
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called",
    );
  }
  return e;
}
function _wrapNativeSuper(e) {
  const n = typeof Map === 'function' ? new Map() : void 0;
  return (_wrapNativeSuper = function (e) {
    if (e === null || !_isNativeFunction(e)) return e;
    if (typeof e !== 'function') { throw new TypeError('Super expression must either be null or a function'); }
    if (void 0 !== n) {
      if (n.has(e)) return n.get(e);
      n.set(e, t);
    }
    function t() {
      return _construct(e, arguments, _getPrototypeOf(this).constructor);
    }
    return (
      (t.prototype = Object.create(e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0,
        },
      })),
      _setPrototypeOf(t, e)
    );
  })(e);
}
function _construct(e, t, n) {
  return (_construct = _isNativeReflectConstruct()
    ? Reflect.construct
    : function (e, t, n) {
      let r = [null];
      r.push.apply(r, t);
      r = new (Function.bind.apply(e, r))();
      return n && _setPrototypeOf(r, n.prototype), r;
    }).apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if (typeof Proxy === 'function') return !0;
  try {
    return (
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], () => {})),
      !0
    );
  } catch (e) {
    return !1;
  }
}
function _isNativeFunction(e) {
  return Function.toString.call(e).indexOf('[native code]') !== -1;
}
function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf
    || function (e, t) {
      return (e.__proto__ = t), e;
    })(e, t);
}
function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
}
const cssHelpers = Object.freeze({
  sliderBackgroundColor: 'tomato',
  sliderBorderColor: '#8b8b8b',
  sliderBorderRadius: '4px',
  sliderCircleSize: 20,
  sliderCircleBackgroundColor: '#ffffff',
  sliderCircleFocusColor: '#0074cc',
  sliderCommonSize: '0.5em',
  rangeInputLabelWidth: '7em',
});
const constants = Object.freeze({
  MIN: 'min',
  MAX: 'max',
  SLIDER_ID: 'minMaxSlider',
  MIN_LABEL_ID: 'minLabel',
  MAX_LABEL_ID: 'maxLabel',
  RANGE_STOPPED_EVENTS: ['mouseup', 'touchend', 'keyup'],
  CUSTOM_EVENT_TO_EMIT_NAME: 'range-changed',
  RANGE_INPUT_DATA_LABEL_MIN: 'data-range-input-label-min',
  RANGE_INPUT_DATA_LABEL_MAX: 'data-range-input-label-max',
});
const template = document.createElement('template');
template.innerHTML = '\n      <style>\n        .min-max-slider { \n          position: relative;\n          width: 100%;\n          text-align: center;\n        }\n           \n        .min-max-slider > label {\n          position: absolute;\n          left: -10000px;\n          top: auto;\n          width: 1px;\n          height: 1px;\n          overflow: hidden;\n        }\n          \n        .min-max-slider > .legend {\n          display: flex;\n          justify-content: space-between;\n        }\n          \n        .min-max-slider > .legend > * {\n          font-size: small;\n        }\n          \n        .min-max-slider > .range-input {\n          --sliderColor: '
  .concat(
    cssHelpers.sliderCircleBackgroundColor,
    ';\n          --sliderBorderColor: ',
  )
  .concat(
    cssHelpers.sliderBorderColor,
    ';\n          --sliderFocusBorderColor: ',
  )
  .concat(
    cssHelpers.sliderCircleFocusColor,
    ';\n          cursor: pointer;\n          position: absolute;\n          -webkit-appearance: none;\n          outline: none !important;\n          background: transparent;\n          background-image: linear-gradient(to bottom, transparent 0%, transparent 30%, ',
  )
  .concat(cssHelpers.sliderBackgroundColor, ' 30%, ')
  .concat(
    cssHelpers.sliderBackgroundColor,
    ' 60%, transparent 60%, transparent 100%);\n        }\n          \n        .min-max-slider > .range-input::-webkit-slider-thumb {\n          -webkit-appearance: none;\n          appearance: none;\n          width: ',
  )
  .concat(cssHelpers.sliderCircleSize, 'px;\n          height: ')
  .concat(
    cssHelpers.sliderCircleSize,
    'px;\n          background-color: var(--sliderColor);\n          cursor: pointer;\n          border: 1px solid var(--sliderBorderColor);\n          border-radius: 100%;\n        }\n        \n        .min-max-slider > .range-input::-moz-range-thumb {\n          width: ',
  )
  .concat(cssHelpers.sliderCircleSize, 'px;\n          height: ')
  .concat(
    cssHelpers.sliderCircleSize,
    'px;\n          background-color: var(--sliderColor);\n          cursor: pointer;\n          border: 1px solid var(--sliderBorderColor);\n          border-radius: 100%;\n        } \n          \n        .min-max-slider > .range-input::-webkit-slider-runnable-track,  \n        .min-max-slider > .range-input::-moz-range-track {\n          cursor: pointer;\n        }\n          \n        .min-max-slider > .range-input:focus::-webkit-slider-thumb {\n          /* Accessible border on focus */\n          border: 2px solid var(--sliderFocusBorderColor);\n        }\n\n        .min-max-slider > .range-input:focus::-moz-range-thumb {\n            /* Accessible border on focus */\n            border: 2px solid var(--sliderFocusBorderColor);\n        }\n          \n        span.value {\n          height: 1.7em;\n          font-weight: bold;\n          display: inline-block;\n        }\n      \n        span.value.upper::before {\n          content: "',
    '\\FE63',
    '";\n          white-space: pre;\n          display: inline-block;\n          padding: 0 ',
  )
  .concat(
    cssHelpers.sliderCommonSize,
    ';\n        }\n\n        .range-input-dash-icon {\n          padding: 0 ',
  )
  .concat(
    cssHelpers.sliderCommonSize,
    ';\n        }\n\n        .range-input-label {\n            border: 1px solid',
  )

  .concat(cssHelpers.sliderBorderColor, ';\n            width: ')
  .concat(cssHelpers.rangeInputLabelWidth, ';\n         border-radius: ')
  .concat(cssHelpers.sliderBorderRadius, ';\n            padding: ')
  .concat(
    cssHelpers.sliderCommonSize,
    ';\n        }\n      </style>\n      \n      <div id="',
  )
  .concat(constants.SLIDER_ID, '" class="min-max-slider"></div>\n  ');
const SimpleRange = (function () {
  _inherits(n, _wrapNativeSuper(HTMLElement));
  const e = _createSuper(n);
  function n() {
    let t;
    return (
      _classCallCheck(this, n),
      ((t = e.call(this)).emitRangeSelection = function () {
        return t.emitRange();
      }),
      (t.onRangeInput = function (e) {
        return t.update(e.target);
      }),
      t.attachShadow({ mode: 'open' }),
      t.shadowRoot.appendChild(template.content.cloneNode(!0)),
      t
    );
  }
  return (
    _createClass(
      n,
      [
        {
          key: 'sliderId',
          get() {
            return this.getAttribute('id');
          },
        },
        {
          key: 'minValue',
          get() {
            return this.getAttribute('min-value');
          },
        },
        {
          key: 'maxValue',
          get() {
            return this.getAttribute('max-value');
          },
        },
        {
          key: 'minRange',
          get() {
            return (
              parseInt(this.getAttribute('min-range'))
              || parseInt(this.getAttribute('min'))
              || 1
            );
          },
          set(e) {
            this.setAttribute('min-range', e), this.setAttribute('min', e);
          },
        },
        {
          key: 'maxRange',
          get() {
            return (
              parseInt(this.getAttribute('max-range'))
              || parseInt(this.getAttribute('max'))
              || 0
            );
          },
          set(e) {
            this.setAttribute('max-range', e), this.setAttribute('max', e);
          },
        },
        {
          key: 'numberOfLegendItemsToShow',
          get() {
            const e = parseInt(
              this.getAttribute('number-of-legend-items-to-show'),
            );
            return e && e > 1 ? e : 2;
          },
        },
        {
          key: 'hideLegend',
          get() {
            return this.hasAttribute('hide-legend');
          },
        },
        {
          key: 'hideLabel',
          get() {
            return this.hasAttribute('hide-label');
          },
        },
        {
          key: 'inputsForLabels',
          get() {
            return this.hasAttribute('inputs-for-labels');
          },
        },
        {
          key: 'sliderColor',
          get() {
            return this.getAttribute('slider-color');
          },
        },
        {
          key: 'circleColor',
          get() {
            return this.getAttribute('circle-color');
          },
        },
        {
          key: 'circleBorderColor',
          get() {
            return this.getAttribute('circle-border-color');
          },
        },
        {
          key: 'circleFocusBorderColor',
          get() {
            return this.getAttribute('circle-focus-border-color');
          },
        },
        {
          key: 'eventNameToEmitOnChange',
          get() {
            return (
              this.getAttribute('event-name-to-emit-on-change')
              || constants.CUSTOM_EVENT_TO_EMIT_NAME
            );
          },
        },
        {
          key: 'attributeChangedCallback',
          value(e, t, n) {
            switch (e) {
              case 'min-label':
                if (!n) return;
                var r = this.getEl(constants.MIN_LABEL_ID);
                if (!r) return;
                r.innerText = n;
                break;
              case 'max-label':
                if (!n) return;
                r = this.getEl(constants.MAX_LABEL_ID);
                if (!r) return;
                r.innerText = n;
                break;
              case 'min-range':
              case 'min':
                if (isNaN(n) || t === n) return;
                this.minRange = n;
                break;
              case 'max-range':
              case 'max':
                if (isNaN(n) || t === n) return;
                this.maxRange = n;
            }
            this.init();
          },
        },
        {
          key: 'connectedCallback',
          value() {
            this.init();
          },
        },
        {
          key: 'disconnectedCallback',
          value() {
            let e = this.getEl(constants.SLIDER_ID);
            var t = e.querySelector('#'.concat(constants.MIN));
            this.removeEventListeners(
              t,
              constants.RANGE_STOPPED_EVENTS,
              this.emitRangeSelection,
              !1,
            ),
            this.removeEventListeners(t, ['input'], this.onRangeInput, !1);
            var t = e.querySelector('#'.concat(constants.MAX));
            this.removeEventListeners(
              t,
              constants.RANGE_STOPPED_EVENTS,
              this.emitRangeSelection,
              !1,
            ),
            this.removeEventListeners(t, ['input'], this.onRangeInput, !1),
            this.inputsForLabels
                && ((t = e.querySelector(
                  '['.concat(constants.RANGE_INPUT_DATA_LABEL_MIN, ']'),
                )),
                (e = e.querySelector(
                  '['.concat(constants.RANGE_INPUT_DATA_LABEL_MAX, ']'),
                )),
                this.removeEventListeners(t, ['input'], this.onRangeInput, !1),
                this.removeEventListeners(e, ['input'], this.onRangeInput, !1),
                this.removeEventListeners(
                  t,
                  ['blur'],
                  this.emitRangeSelection,
                  !1,
                ),
                this.removeEventListeners(
                  e,
                  ['blur'],
                  this.emitRangeSelection,
                  !1,
                ));
          },
        },
        {
          key: 'dispatchCustomEvent',
          value(e, t) {
            (e || window).dispatchEvent(t);
          },
        },
        {
          key: 'addMultipleEventListeners',
          value(t, e, n) {
            e.forEach((e) => t.addEventListener(e, n));
          },
        },
        {
          key: 'removeEventListeners',
          value(t, e, n, r) {
            e.forEach((e) => {
              t.removeEventListener(e, n, r);
            });
          },
        },
        {
          key: 'getEl',
          value(e) {
            return this.shadowRoot.getElementById(e);
          },
        },
        {
          key: 'init',
          value() {
            const e = this.getEl(constants.SLIDER_ID);
            this.setInitialSliderState(e), this.setupColors();
            const t = e.querySelector('#'.concat(constants.MIN));
            const n = e.querySelector('#'.concat(constants.MAX));
            t.setAttribute('data-value', this.minValue),
            n.setAttribute('data-value', this.maxValue),
            e.setAttribute('data-range-width', e.offsetWidth),
            this.createLabels(e, t),
            this.createLegend(e);
            const r = (this.minRange + this.maxRange) / 2;
            this.draw(e, r),
            t.addEventListener('input', this.onRangeInput),
            n.addEventListener('input', this.onRangeInput),
            this.addMultipleEventListeners(
              t,
              constants.RANGE_STOPPED_EVENTS,
              this.emitRangeSelection,
            ),
            this.addMultipleEventListeners(
              n,
              constants.RANGE_STOPPED_EVENTS,
              this.emitRangeSelection,
            );
          },
        },
        {
          key: 'setInitialSliderState',
          value(e) {
            e.innerHTML = '\n        <label id="'
              .concat(constants.MIN_LABEL_ID, '" for="')
              .concat(constants.MIN, '">Minimum</label> \n        <input id="')
              .concat(constants.MIN, '" data-value="')
              .concat(this.minValue, '" class="range-input" name="')
              .concat(
                constants.MIN,
                '" type="range" step="1" />\n        <label id="',
              )
              .concat(constants.MAX_LABEL_ID, '" for="')
              .concat(constants.MAX, '">Maximum</label>\n        <input id="')
              .concat(constants.MAX, '" data-value="')
              .concat(this.maxValue, '" class="range-input" name="')
              .concat(constants.MAX, '" type="range" step="1" />\n      ');
          },
        },
        {
          key: 'emitRange',
          value() {
            const e = this.getEl(constants.SLIDER_ID);
            const t = e.querySelector('#'.concat(constants.MIN));
            const n = e.querySelector('#'.concat(constants.MAX));
            this.dispatchCustomEvent(
              e,
              new CustomEvent(this.eventNameToEmitOnChange, {
                bubbles: !0,
                composed: !0,
                detail: {
                  sliderId: this.sliderId,
                  minRangeValue: Math.floor(t.getAttribute('data-value')),
                  maxRangeValue: Math.floor(n.getAttribute('data-value')),
                },
              }),
            );
          },
        },
        {
          key: 'draw',
          value(e, t) {
            const n = e.querySelector('#'.concat(constants.MIN));
            n.setAttribute(constants.MIN, this.minRange),
            n.setAttribute(constants.MAX, t);
            const r = e.querySelector('#'.concat(constants.MAX));
            r.setAttribute(constants.MIN, t),
            r.setAttribute(constants.MAX, this.maxRange);
            var i = parseInt(e.getAttribute('data-range-width'));
            let o = cssHelpers.sliderCircleSize;
            (n.style.width = ''.concat(
              parseInt(
                o
                  + ((t - this.minRange) / (this.maxRange - this.minRange))
                    * (i - 2 * o),
              ),
              'px',
            )),
            (r.style.width = ''.concat(
              parseInt(
                o
                    + ((this.maxRange - t) / (this.maxRange - this.minRange))
                      * (i - 2 * o),
              ),
              'px',
            )),
            (n.style.left = '0px'),
            (r.style.left = ''.concat(parseInt(n.style.width), 'px'));
            let a;
            var t = e.querySelector('.lower');
            var i = n.offsetHeight;
            this.hideLabel
              || ((a = this.inputsForLabels ? t.offsetHeight + 5 : t.offsetHeight),
              (n.style.top = ''.concat(a, 'px')),
              (r.style.top = ''.concat(a, 'px')),
              (i += a)),
            this.hideLegend
                || ((o = e.querySelector('.legend')),
                (a = this.inputsForLabels
                  ? n.offsetHeight + 5
                  : n.offsetHeight),
                (o.style.paddingTop = ''.concat(a, 'px')),
                (i += +o.offsetHeight)),
            (e.style.height = ''.concat(i, 'px')),
            (r.value = r.getAttribute('data-value')),
            (n.value = n.getAttribute('data-value')),
            this.hideLabel
                || ((e = e.querySelector('.upper')),
                this.inputsForLabels
                  ? ((t.value = n.getAttribute('data-value')),
                  (e.value = r.getAttribute('data-value')))
                  : ((t.innerHTML = n.getAttribute('data-value')),
                  (e.innerHTML = r.getAttribute('data-value'))));
          },
        },
        {
          key: 'update',
          value(e) {
            const t = e.parentElement;
            var n = e.hasAttribute(constants.RANGE_INPUT_DATA_LABEL_MIN)
              || e.hasAttribute(constants.RANGE_INPUT_DATA_LABEL_MAX)
              ? ((r = '['.concat(constants.RANGE_INPUT_DATA_LABEL_MIN, ']')),
              '['.concat(constants.RANGE_INPUT_DATA_LABEL_MAX, ']'))
              : ((r = '#'.concat(constants.MIN)), '#'.concat(constants.MAX));
            var r = t.querySelector(r);
            var n = t.querySelector(n);
            var r = Math.floor(parseInt(r.value));
            var n = Math.floor(parseInt(n.value));
            this.isValidRangeSelection(e, r, n)
              && (t
                .querySelector('#'.concat(constants.MIN))
                .setAttribute('data-value', r),
              t
                .querySelector('#'.concat(constants.MAX))
                .setAttribute('data-value', n),
              (n = Math.floor((r + n) / 2)),
              this.draw(t, n));
          },
        },
        {
          key: 'isValidRangeSelection',
          value(e, t, n) {
            return this.inputsForLabels
              ? e.hasAttribute(constants.RANGE_INPUT_DATA_LABEL_MIN)
                || e.getAttribute('id') === constants.MIN
                ? t > this.minRange && t < this.maxRange && t < n
                : n > this.minRange && n < this.maxRange && t < n
              : t !== n;
          },
        },
        {
          key: 'setupColors',
          value() {
            const t = this;
            this.shadowRoot
              .querySelectorAll('.min-max-slider > .range-input')
              .forEach((e) => {
                t.sliderColor
                  && (e.style.backgroundImage = 'linear-gradient(to bottom, transparent 0%, transparent 30%, '
                    .concat(t.sliderColor, ' 30%, ')
                    .concat(
                      t.sliderColor,
                      ' 60%, transparent 60%, transparent 100%)',
                    )),
                t.circleColor
                    && e.style.setProperty('--sliderColor', t.circleColor),
                t.circleBorderColor
                    && e.style.setProperty(
                      '--sliderBorderColor',
                      t.circleBorderColor,
                    ),
                t.circleFocusBorderColor
                    && e.style.setProperty(
                      '--sliderFocusBorderColor',
                      t.circleFocusBorderColor,
                    );
              });
          },
        },
        {
          key: 'createLegend',
          value(e) {
            if (!this.hideLegend) {
              const t = document.createElement('div');
              t.classList.add('legend');
              for (let n = [], r = 0; r < this.numberOfLegendItemsToShow; r++) {
                n[r] = document.createElement('div');
                const i = Math.round(
                  this.minRange
                    + (r / (this.numberOfLegendItemsToShow - 1))
                      * (this.maxRange - this.minRange),
                );
                n[r].appendChild(document.createTextNode(i)),
                t.appendChild(n[r]);
              }
              e.appendChild(t);
            }
          },
        },
        {
          key: 'createLabels',
          value(e, t) {
            let n;
            let r;
            let i;
            this.hideLabel
              || ((n = this.inputsForLabels ? 'input' : 'span'),
              (r = document.createElement(n)),
              (i = document.createElement(n)),
              r.classList.add('range-'.concat(n, '-label'), 'lower', 'value'),
              i.classList.add('range-'.concat(n, '-label'), 'upper', 'value'),
              this.inputsForLabels
                ? ((r.value = this.minRange),
                (i.value = this.maxRange),
                r.setAttribute('type', 'number'),
                r.setAttribute(constants.MIN, this.minRange),
                r.setAttribute(constants.MAX, this.maxRange),
                r.setAttribute(constants.RANGE_INPUT_DATA_LABEL_MIN, ''),
                i.setAttribute('type', 'number'),
                i.setAttribute(constants.MIN, this.minRange),
                i.setAttribute(constants.MAX, this.maxRange),
                i.setAttribute(constants.RANGE_INPUT_DATA_LABEL_MAX, ''),
                r.addEventListener('input', this.onRangeInput),
                i.addEventListener('input', this.onRangeInput),
                r.addEventListener('blur', this.emitRangeSelection),
                i.addEventListener('blur', this.emitRangeSelection))
                : (r.appendChild(document.createTextNode(this.minRange)),
                i.appendChild(document.createTextNode(this.maxRange))),
              e.insertBefore(r, t.previousElementSibling),
              e.insertBefore(i, t.previousElementSibling),
              this.inputsForLabels
                && ((i = document.createElement('i')).classList.add(
                  'range-input-dash-icon',
                ),
                i.setAttribute('aria-hidden', !0),
                (i.innerHTML = '&#65123'),
                e.insertBefore(
                  i,
                  t.previousElementSibling.previousElementSibling,
                )));
          },
        },
      ],
      [
        {
          key: 'observedAttributes',
          get() {
            return [
              'min-label',
              'max-label',
              'min-range',
              'max-range',
              'min',
              'max',
            ];
          },
        },
      ],
    ),
    n
  );
}());
window.customElements.define('range-selector', SimpleRange);
